import React from 'react'
import CommonBanner from '../../components/common/CommonBanner'
import Banner from "../../Assets/Career/careearBanner.png";
import JobList from '../../components/User/Career/JobList';
import InterviewTipsSection from '../../components/User/Career/InterviewTipsSection';
import FAQBenefitsSection from '../../components/User/Career/FAQBenefitsSection';
const Career = () => {
  return (
    <div className='overflow-hidden'>
        <CommonBanner backgroundImage={Banner} title="Career" subheading="Home/Career" />
        <JobList />
        <InterviewTipsSection />
        <FAQBenefitsSection />
    </div>)
}

export default Career